/**
* 
* @des 设置密码模块
* 
*/

// import store from '@/store/index'


import { post ,prefix } from './base'

// 设置密码
export function setPassword(params) {
    return post(prefix+'setPassword', params)
}

